import { render } from "./SocialLoginRegistration.vue?vue&type=template&id=c9faf992"
import script from "./SocialLoginRegistration.vue?vue&type=script&lang=js"
export * from "./SocialLoginRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__